<div class="section-heading">

  <div>

    <span class="section-kicker">
      Website media
    </span>

    <h2>
      Featured YouTube video
    </h2>

    <p>
      Paste a regular YouTube link.
      The portal will create the embed automatically.
    </p>

  </div>

</div>


<div class="panel youtube-panel">

  <div class="form-field full-width">

    <label for="youtube-link">
      YouTube link
    </label>

    <div class="input-action-row">

      <input
        id="youtube-link"
        type="url"
        [(ngModel)]="youtubeInput"
        placeholder="https://www.youtube.com/watch?v=..."
        (keyup.enter)="previewYouTube()"
      />

      <button
        type="button"
        class="secondary-btn"
        (click)="previewYouTube()"
      >
        Preview
      </button>

    </div>

    <small>
      Watch, share, Shorts and embed links are supported.
    </small>

    <span
      *ngIf="youtubeError"
      class="field-error"
    >
      {{ youtubeError }}
    </span>

  </div>


  <div
    class="video-preview"
    [class.empty]="!youtubePreviewUrl"
  >

    <iframe
      *ngIf="youtubePreviewUrl"
      [src]="youtubePreviewUrl"
      title="Featured YouTube video preview"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>

    <div
      *ngIf="!youtubePreviewUrl"
      class="empty-state"
    >

      <span>
        ▶
      </span>

      <strong>
        Video preview
      </strong>

      <p>
        Enter a valid YouTube link to preview it here.
      </p>

    </div>

  </div>


  <div class="form-actions">

    <span
      *ngIf="youtubeVideoId"
      class="saved-detail"
    >
      Video ID: {{ youtubeVideoId }}
    </span>

    <button
      type="button"
      class="primary-btn"
      (click)="saveYouTube()"
    >
      Save featured video
    </button>

  </div>

</div>